import {
	ZONE_MANAGE_GET,
	ZONE_MANAGE_SUCCESS,
	ZONE_CREATE,
	ZONE_RENAME,
	ZONE_DELETE,
	ZONE_ASSIGN,
	ZONE_COPY,
} from '../constants/zone';

// État de la fenêtre de gestion des zones. Distinct de state.entity.zone, qui
// sert au sélecteur et ne porte que les établissements déjà rattachés : ici on
// a besoin de tout le parc, y compris ceux qui n'ont pas encore de zone.
//
// `busy` couvre les quatre écritures : elles se suivent dans une même fenêtre
// et ne doivent pas se chevaucher.
const initialState = {
	loading: false,
	loaded: false,
	busy: false,
	zones: [],
	children: [],
};

export default function zoneManagementReducer(state = initialState, action) {
	switch (action.type) {
		case ZONE_MANAGE_GET:
			return { ...state, loading: true };
		case ZONE_MANAGE_SUCCESS:
			return {
				...state,
				loading: false,
				loaded: true,
				busy: false,
				zones: action.zones,
				children: action.children,
			};
		case ZONE_CREATE:
		case ZONE_RENAME:
		case ZONE_DELETE:
		case ZONE_ASSIGN:
		case ZONE_COPY:
			return { ...state, busy: true };
		default:
			return state;
	}
}
